import { render, staticRenderFns } from "./ReleasePerson.vue?vue&type=template&id=7cf957ad&scoped=true&"
import script from "./ReleasePerson.vue?vue&type=script&lang=js&"
export * from "./ReleasePerson.vue?vue&type=script&lang=js&"
import style0 from "./ReleasePerson.vue?vue&type=style&index=0&id=7cf957ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf957ad",
  null
  
)

export default component.exports